export const PACKAGES_GRID_STYLES = {
  root: "w-full min-w-0",
  header: "flex items-start justify-between gap-4",
  nav: "hidden md:flex",
  navButton:
    "flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white text-ticketon-gray-600 shadow-sm transition-colors hover:bg-ticketon-light-sky-blue",
  title: "text-[20px] md:text-[24px] font-bold text-ticketon-dark-text",
  description: "mt-2 text-[13px] text-ticketon-gray-600",
  gridWrapper: "relative mt-4 min-w-0 max-w-full overflow-hidden md:overflow-visible",
  grid: "flex gap-4 overflow-x-auto py-2 max-md:px-2 max-md:pb-4 scrollbar-hide snap-x snap-mandatory md:grid md:grid-cols-2 md:overflow-visible lg:grid-cols-4",
  sideNavButton:
    "absolute top-1/2 -translate-y-1/2 z-10 flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white text-ticketon-gray-600 shadow-sm transition-colors hover:bg-ticketon-light-sky-blue",
  sideNavLeft: "left-1 md:-left-5",
  sideNavRight: "right-1 md:-right-5",
} as const;

export const PACKAGE_CARD_STYLES = {
  shell: "min-w-[280px] snap-start rounded-[16px] shadow-ticketon-card transition-shadow hover:shadow-ticketon-card-alt md:min-w-0",
  root: "flex h-full min-h-0 w-full flex-col overflow-hidden rounded-[16px] bg-white",
  imageWrapper: "relative aspect-[290/200] w-full overflow-hidden",
  image: "h-full w-full object-cover",
  body: "flex flex-1 flex-col gap-[14px] px-4 pb-4 pt-3",
  name: "line-clamp-2 text-[14px] font-semibold text-ticketon-dark-text",
  location: "text-[12px] text-ticketon-gray-600",
  detailsBlock: "flex flex-col gap-1",
  detailRow: "flex items-center gap-2 text-[11px] font-semibold leading-[1] text-ticketon-gray-600",
  detailIcon: "h-[14px] w-[16px] shrink-0 text-ticketon-gray-600",
  promoChip:
    "inline-flex w-fit self-end items-center gap-2 rounded-[8px] bg-ticketon-blue px-3 py-1 text-[12px] font-semibold text-white",
  promoIcon: "h-[13px] w-[16px] shrink-0",
  priceBlock: "mt-auto flex flex-col items-end text-right",
  datesLabel: "mt-1 text-[12px] font-medium leading-[1] text-ticketon-gray-600",
  price:
    "mt-1 inline-flex items-center gap-1 whitespace-nowrap text-[20px] font-bold leading-[1] text-ticketon-gray-600",
  priceInfoIcon: "inline-block h-[20px] w-[20px] align-[-3px]",
  originalPrice:
    "whitespace-nowrap text-[12px] font-medium leading-[1] text-ticketon-gray-600 line-through",
  pricePerLabel: "text-[12px] font-medium leading-[1] text-ticketon-gray-600",
  foundAgoLabel: "text-[12px] font-medium leading-[1] text-ticketon-gray-600",
} as const;
